import React, { useState,useEffect } from "react";
import { Upload, Button, Input, Select, DatePicker, Switch, Breadcrumb,message  } from "antd";
import { UploadOutlined, RightOutlined, HomeOutlined } from "@ant-design/icons";
import Layout from "Layout"; // nếu bạn có layout, nếu không remove
import { mixGetV1,mixPutV1,mixPostV1 } from "services/mixin";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";

export default function CustomerDetail() {
    const [status, setStatus] = useState(true);
    const [lifetime, setLifetime] = useState(false);
    const [verifyPhone, setVerifyPhone] = useState(false);
    const [avatar, setAvatar] = useState<string | null>(null);
    const { id } = useParams<{ id: string }>();
    const [customer, setCustomer] = useState<any>(null);
    const [fileList, setFileList] = useState<any[]>([]);
    const [avatarPath, setAvatarPath] = useState<string>("");
    const [newPassword, setNewPassword] = useState<string>("");
    const [countries, setCountries] = useState<{id: number, name: string}[]>([]);
    const BASE_URL = "https://aihub-api.buso.asia";
    

    const handleSave = async () => {
        try {
            const payload = {
                ...customer,
                is_active: status ? 1 : 0,          // cập nhật trạng thái
                is_lifetime: customer.is_lifetime ? 1 : 0,
                is_phone_auth: customer.is_phone_auth ? 1 : 0,
                image: customer.avatar,
                name: `${customer.first_name || ""} ${customer.last_name || ""}`.trim(),
                ...(newPassword ? { password: newPassword } : {}),
            };

            const res = await mixPutV1(`/api/v1/be/customer/${id}`, payload);
            if (res?.status) {
                message.success("Cập nhật khách hàng thành công!");
                setCustomer(res.data); // cập nhật lại state từ API
            } else {
                message.error(res?.msg || "Cập nhật thất bại!");
            }
        } catch (error) {
            console.log(error);
            message.error("Có lỗi xảy ra khi lưu dữ liệu!");
        }
    };

    const handleUploadAvatar  = async (file, name) => {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('name', name);
        
        const baseURL = 'https://aihub-api.buso.asia';
        
        const response = await fetch(`${baseURL}/api/v1/photo_library`, {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : '',
            }
        });
        
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }
        
        return await response.json();
    };

    const getCountries = async () => {
        try {
            const res = await mixGetV1('/api/v1/fe/country');

            if (res?.status && Array.isArray(res.data?.items)) {
                setCountries(res.data.items);
            }
        } catch (err) {
            console.log('Lỗi lấy danh sách quốc gia', err);
        }
    };


    useEffect(() => {
        getCountries();
    }, []);



    const getCustomerDetail = async () => {
        try {
        const res = await mixGetV1(`/api/v1/be/customer/${id}`);
        if (res?.status) {
            setCustomer(res.data);
            if (res.data.avatar) {
                if (res.data.avatar.startsWith("http")) {
                    setAvatar(res.data.avatar);
                } else {
                    setAvatar(BASE_URL + res.data.avatar);
                }
            } else {
                setAvatar(null);
            }
            setStatus(res.data.is_active === 1);
            setLifetime(res.data.is_lifetime === 1);
            setVerifyPhone(res.data.is_phone_auth === 1);
        }
        } catch (error) {
        console.log(error);
        }
    };

    useEffect(() => {
        if (id) getCustomerDetail();
    }, [id]);

    if (!customer) return <Layout>Loading...</Layout>;

    return (
        <Layout>
            <div style={{ marginBottom: 16, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                <h2 style={{ fontWeight: 600, fontSize: 24, marginBottom: 0, color: "#6e6b7b", borderRight: "1px solid #d6dce1", paddingRight: 12 }}>
                    Thông tin khách hàng
                </h2>
                <Breadcrumb
                    separator={<RightOutlined style={{ fontSize: 12, color: "#6e6b7b" }} />}
                    items={[
                        {
                            title: (
                                <a href="#">
                                    <HomeOutlined style={{ color: "#096dd9", fontSize: 16 }} />
                                </a>
                            ),
                        },
                        {
                            title: (
                                <a href="/">
                                    Danh sách
                                </a>
                            ),
                        },
                        { title: "Chi tiết" },
                    ]}
                />
            </div>
            <div>
                <div className="bg-white rounded-xl border p-6 shadow-sm">
                    <div className="mb-6">
                        <div className="inline-flex items-center gap-2 !bg-[#1677ff] text-white font-medium px-4 py-2 rounded-lg">
                            <div className="icon-svg text-[18px] w-[18px]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="mr-50 feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                            </div>
                            Thông tin khách hàng
                        </div>
                    </div>
                    {/* AVATAR UPLOAD */}
                    <div className="flex flex-col md:flex-row gap-6">

                        <div className="flex items-center gap-4">
                            <div className="w-28 h-28 bg-gray-200 rounded-md overflow-hidden bg-gray-300">
                                {avatar ? (
                                    <img src={avatar} alt="avatar" className="w-full h-full object-cover" />
                                ) : (
                                    <div className="w-full h-full bg-gray-300" />
                                )}
                            </div>
                            <Upload
                                showUploadList={false}
                                beforeUpload={async (file) => {
                                    try {
                                        // Hiển thị preview ngay
                                        const url = URL.createObjectURL(file);
                                        setAvatar(url);

                                        // Upload file lên server
                                        const res = await handleUploadAvatar(file, `${customer.first_name || "avatar"}_${Date.now()}`);

                                        if (res.status && res.data?.image) {
                                            // Lấy path relative để gửi lên API
                                            let path = res.data.image;
                                            if (path.startsWith("https://aihub-api.buso.asia")) {
                                                path = path.replace("https://aihub-api.buso.asia", "");
                                            }

                                            // Lưu path relative vào customer.avatar để gửi khi lưu
                                            setCustomer(prev => ({ ...prev, avatar: path }));

                                            // Lưu full URL vào state avatar để hiển thị preview
                                            setAvatar(res.data.image);

                                            message.success("Upload avatar thành công!");
                                        } else {
                                            message.error("Upload thất bại!");
                                        }
                                    } catch (err: any) {
                                        message.error("Lỗi upload: " + err.message);
                                    }

                                    return false; // ngăn Upload tự gửi file
                                }}
                            >
                                <div className="text-[21px] font-medium text-[#5e5873]">Avatar</div>
                                <Button
                                    type="primary"
                                    className="mt-3 !bg-blue-600"
                                    icon={<UploadOutlined />}
                                >
                                    Thay đổi
                                </Button>
                            </Upload>




                            {/* <Upload
                                showUploadList={false}
                                beforeUpload={(file) => {
                                    const url = URL.createObjectURL(file);
                                    setAvatar(url);
                                    return false;
                                }}
                            >

                                <div className="text-[21px] font-medium text-[#5e5873]">Avatar</div>
                                <Button
                                    type="primary"
                                    className="mt-3 !bg-blue-600"
                                    icon={<UploadOutlined />}
                                >
                                    Thay đổi
                                </Button>
                            </Upload> */}
                        </div>
                    </div>

                    {/* FORM GRID */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">

                        {/* Họ */}
                        <div>
                            <label className="block font-medium mb-1">Họ</label>
                            <Input value={customer.first_name || ""}  onChange={(e) => setCustomer({ ...customer, first_name: e.target.value })}/>
                        </div>

                        {/* Tên */}
                        <div>
                            <label className="block font-medium mb-1">Tên</label>
                            <Input value={customer.last_name || ""}  onChange={(e) => setCustomer({ ...customer, last_name: e.target.value })}/>
                        </div>

                        {/* Email */}
                        <div>
                            <label className="block font-medium mb-1">Email</label>
                            <Input value={customer.email || ""}  onChange={(e) => setCustomer({ ...customer, email: e.target.value })}/>
                        </div>

                        {/* Điện thoại */}
                        <div>
                            <label className="block font-medium mb-1">Điện thoại</label>
                            <Input value={customer.phone || ""}  onChange={(e) => setCustomer({ ...customer, phone: e.target.value })}/>
                        </div>

                        {/* Mật khẩu mới */}
                        <div>
                            <label className="block font-medium mb-1">Mật khẩu mới</label>
                            <Input.Password value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="Nhập pass" />
                        </div>

                        {/* Quốc gia */}
                        <div>
                            <label className="block font-medium mb-1">Quốc gia</label>
                            <Select placeholder="Chọn quốc gia"  value={customer.country_id} onChange={(value) => setCustomer({ ...customer, country_id: value })}  className="w-full">
                                {countries.map(country => (
                                    <Select.Option key={country.id} value={country.id}>
                                        {country.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>

                        {/* Số lần sử dụng */}
                        <div>
                            <label className="block font-medium mb-1">Số lần sử dụng</label>
                            <Input value={customer.number_use || ""}  onChange={(e) => setCustomer({ ...customer, number_use: e.target.value })}/>
                        </div>

                        {/* Giới tính */}
                        <div>
                            <label className="block font-medium mb-1">Giới tính</label>
                            <Input placeholder="Giới tính" value={customer.gender || ""}  onChange={(e) => setCustomer({ ...customer, gender: e.target.value })}/>
                        </div>

                        {/* Ngày sinh */}
                        <DatePicker
                            className="w-full"
                            format="DD/MM/YYYY"
                            value={customer.birthday ? dayjs(customer.birthday) : null} // dayjs tự nhận ISO 8601
                            onChange={(date) =>
                                setCustomer({ ...customer, birthday: date ? date.format("YYYY-MM-DD") : null })
                            }
                        />
                        {/* <div>
                            <label className="block font-medium mb-1">Ngày sinh</label>
                            <DatePicker value={customer.birthday || ""} onChange={(e) => setCustomer({ ...customer, birthday: e.target.value })}  className="w-full" format="DD/MM/YYYY" />
                        </div> */}

                        {/* Trạng thái */}
                        <div>
                            <label className="block font-medium mb-1">Trạng thái</label>
                            <div className="flex items-center gap-3 mt-2">
                                <Switch checked={status} onChange={setStatus} />
                            </div>
                        </div>

                        {/* Lifetime */}
                        <div>
                            <label className="block font-medium mb-1">Tài khoản lifetime</label>
                            <div className="flex items-center gap-3 mt-2">
                                <Switch checked={customer.is_lifetime === 1} onChange={(checked) =>setCustomer({ ...customer, is_lifetime: checked ? 1 : 0 }) } />
                            </div>
                        </div>

                        {customer.is_lifetime === 1 && (
                            <div>
                                <label className="block font-medium mb-1">Tokens / Tháng</label>
                                <Input placeholder="Tokens / Tháng"   value={customer.number_lifetime} onChange={(e) => setCustomer({ ...customer, number_lifetime: e.target.value })}/>
                            </div>
                        )}

                        {/* Xác thực SDT */}
                        <div>
                            <label className="block font-medium mb-1">Xác thực SDT</label>
                            <div className="flex items-center gap-3 mt-2">
                                <Switch checked={customer.is_phone_auth === 1} onChange={(checked) =>setCustomer({ ...customer, is_phone_auth: checked ? 1 : 0 })}/>
                            </div>
                        </div>

                    </div>

                    {/* SAVE BUTTON */}
                    <div className="flex justify-center mt-8">
                        <Button type="primary" className="!bg-blue-600 px-6 py-2 text-white font-semibold" onClick={handleSave} >
                            Lưu Thay đổi
                        </Button>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
